

// const initialState = {
//   token: null,
//   admin: null,
//   isAuthenticated: false,
//   permissions: [],  // <== New
// };

// export default function authReducer(state = initialState, action) {
//   switch (action.type) {
//     case "LOGIN_SUCCESS":
//       return {
//         ...state,
//         token: action.payload.token,
//         admin: action.payload.admin,
//         isAuthenticated: true,
//       };
//     case "SET_PERMISSIONS":  // <== New
//       return {
//         ...state,
//         permissions: action.payload,
//       };
//     case "LOGIN_FAIL":
//     case "LOGOUT":
//       return {
//         ...state,
//         token: null,
//         admin: null,
//         isAuthenticated: false,
//         permissions: [],
//       };
//     default:
//       return state;
//   }
// }

const initialState = {
  token: null,
  admin: null,
  isAuthenticated: false,
  permissions: [],
  permissionsLoaded: false,          // ← NEW
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        token: action.payload.token,
        admin: action.payload.admin,
        isAuthenticated: true,
        permissionsLoaded: false,    // will be set after fetching permissions
      };

    case "SET_PERMISSIONS":
      return {
        ...state,
        permissions: action.payload,
        permissionsLoaded: true,     // ← mark as loaded
      };

    case "LOGIN_FAIL":
    case "LOGOUT":
      return {
        ...state,
        token: null,
        admin: null,
        isAuthenticated: false,
        permissions: [],
        permissionsLoaded: false,    // reset on logout
      };

    default:
      return state;
  }
}